import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { Button } from '@mui/material'

const LogoutButton: React.FC = () => {
  const { logout } = useAuth0()

  const handleLogout = async (): Promise<void> => {
    await logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    })
  }

  return (
    <Button
      variant='contained'
      onClick={() => { void handleLogout() }}
    >
      Log Out
    </Button>
  )
}

export default LogoutButton
